export default "__VITE_ASSET__DevT51lE__"